// extracted by mini-css-extract-plugin
export default {"main":"Main_main__b2Ziu","w-auto":"Main_w-auto__tqbCM","w-100":"Main_w-100__wTjb4"};